import { Component } from '@angular/core';

@Component({
  selector: 'app-demokratiewerkstatt-category-create',
  templateUrl: './demokratiewerkstatt-category-create.component.html',
  styleUrls: ['./demokratiewerkstatt-category-create.component.css']
})
export class DemokratiewerkstattCategoryCreateComponent {

}
